module.exports = __webpack_public_path__ + "static/media/Acalog ACMS™_ course Information.ac6bf3b6.pdf";